export default {"src":"/_next/static/media/ic-unpin.8bbb9359.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};